export const estadosSolicitudCambio = {
    REGISTRADA: 2,
    APROBADA_PARCIALMENTE: 4,
    APROBADA_POR_ENTIDAD: 8,
    RECHAZADA_POR_ENTIDAD: 12,
    PENDIENTE_VALIDACION:16
};

export const nombreEstadosSolicitudCambio = {
    REGISTRADA: "Registrada",
    APROBADA_PARCIALMENTE: "Aprobada Parcialmente",
    APROBADA_POR_ENTIDAD: "Aprobada Por Entidad",
    RECHAZADA_POR_ENTIDAD: "Rechazada por Entidad",
    PENDIENTE_VALIDACION: "Pendiente de Validacion"
}

export const AccionesSolicitud = {
    APROBAR: "Aprobar",
    RECHAZAR: "Rechazar",
    ELIMINAR: "Eliminar"
}